<template>
    <v-main>
        <v-card class="pa-2">
            <v-card-title class="pt-0 pb-0 justify-center"><h2>OpenAI Management</h2></v-card-title>
        </v-card>
        <v-container v-if="refresh > 0">
            <cardWait />
        </v-container>
        <v-container fluid class="relative ma-2">
            <v-row cols="12">
                <v-col cols="2" class="pr-6">
                    <cardStoreVFY title="Models"/>
                </v-col>
            </v-row>
            <v-row cols="12">
                <v-col cols="2" class="pr-6">
                    <cardRefresh title="Models" :count="models.length" @refreshData="getModels(true)"/>
                </v-col>
                <v-col cols="2" class="pr-6">
                    <cardRefresh title="Files" :count="files.length" @refreshData="getFiles(true)"/>
                </v-col>
                <v-col cols="2" class="pr-6">
                    <cardRefresh title="Assistants" :count="assistants.length" @refreshData="getAssistants(true)"/>
                </v-col>
                <v-col cols="2" class="pr-6">
                    <cardRefresh title="Vector stores" :count="stores.length" @refreshData="getStores(true)"/>
                </v-col>
            </v-row>
        </v-container>
        <navbar title="ARES - OpenAI" type="openai" :home="true" @actionClick="actionClick" />
    </v-main>
</template>

<script>
    import navbar from '@/components/ui/navbars/navbar.vue';

    import cardWait from '@/components/syst/openai/cardWait.vue';
    import cardRefresh from '@/components/syst/openai/cardRefresh.vue';
    import cardStoreVFY from '@/components/syst/openai/cardStoreVFY.vue';


    export default {        
        components: {
            navbar,
            cardWait,
            cardRefresh,
            cardStoreVFY,
        },
        data() {
            return {
                refresh: 0,
                models: [],
                files: [],
                assistants: [],
                stores: [],
            }
        },
        mounted() {
            this.getModels(false);
            this.getFiles(false);
            this.getAssistants(false);
            this.getStores(false);
        },
        methods: {
            getModels(reload) {
                this.refresh += 1;
                this.$axios.post("ares/json/ares/syst/openai/getModels.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getModels"
                    },
                    getModels: {
                        refresh: reload,
                    },
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.refresh -= 1;
                    } else {
                        this.models = res.data.getModels;
                        this.refresh -= 1;
                    }
                });
            },
            getFiles(reload) {
                this.refresh += 1;
                this.$axios.post("ares/json/ares/syst/openai/getFiles.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getFiles"
                    },
                    getFiles: {
                        refresh: reload,
                    },
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.refresh -= 1;
                    } else {
                        this.files = res.data.getFiles;
                        this.refresh -= 1;
                    }
                });
            },
            getAssistants(reload) {
                this.refresh += 1;
                this.$axios.post("ares/json/ares/syst/openai/getAssistants.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAssistants"
                    },
                    getAssistants: {
                        refresh: reload,
                    },
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.refresh -= 1;
                    } else {
                        this.assistants = res.data.getAssistants.assistants;
                        this.refresh -= 1;
                    }
                });
            },
            getStores(reload) {
                this.refresh += 1;
                this.$axios.post("ares/json/ares/syst/openai/getVectorStores.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getVectorStores"
                    },
                    getVectorStores: {
                        refresh: reload,
                    },
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.refresh -= 1;
                    } else {
                        this.stores = res.data.getVectorStores;
                        this.refresh -= 1;
                    }
                });
            },
            // Dummy callback for navBar
            actionClick() {

            },           
            // refreshData(data) {
            //     switch (data) {
            //         case "assistants":
            //             this.getAssistants(true);
            //             break;
            //         default:
            //     }
            // },           
        },
    }
</script>

<style scoped>
</style>
